import React, { Component, useState } from "react";
import styled, { withTheme } from "styled-components";
import Notifications from "../../Utility/Notifications/Notifications";
import { truncateContent } from "@instream-solutions/instream-design-system/src/Utilities/shared";
import { connect } from "react-redux";

import {
  Grid,
  Hidden,
  InputBase,
  Menu,
  MenuItem,
  AppBar as MuiAppBar,
  IconButton as MuiIconButton,
  Toolbar,
  Avatar,
} from "@mui/material";

import { Menu as MenuIcon } from "@mui/icons-material";
import MoreVertIcon from "@mui/icons-material/MoreVert";

import { Search as SearchIcon } from "react-feather";

import { spring_security_logout } from "../../../api/shared/signin";
import { Redirect, withRouter } from "react-router-dom";

import TrialCounter from "@instream-solutions/instream-design-system/lib/Components/TrialCounter/TrialCounter";

import * as actionTypes from "../../../redux/constants";

const AppBar = styled(MuiAppBar)`
  color: ${(props) => props.theme.header.color};
  background-color: #fff;
  box-shadow: ${(props) => props.theme.shadows[1]};
`;

const IconButton = styled(MuiIconButton)`
  svg {
    width: 22px;
    height: 22px;
  }
`;

const Search = styled.div`
  border-radius: 2px;
  display: none;
  position: relative;
  width: 100%;

  ${(props) => props.theme.breakpoints.up("md")} {
    display: block;
  }
`;

const Input = styled(InputBase)`
  color: inherit;
  width: 100%;

  > input {
    color: ${(props) => props.theme.header.search.color};
    padding-top: ${(props) => props.theme.spacing(2.5)}px;
    padding-right: ${(props) => props.theme.spacing(2.5)}px;
    padding-bottom: ${(props) => props.theme.spacing(2.5)}px;
    padding-left: ${(props) => props.theme.spacing(12)}px;
    width: 160px;
  }
`;

const UserAvatar = (props) => {
  return props.imageUrl ? (
    <Avatar variant={"square"} alt={props.name} src={props.imageUrl} />
  ) : (
    <Avatar variant={"square"}>{props.name[0]}</Avatar>
  );
};

const URL_SUBSCRIPTION = "/advisor/billing/subscription";
const URL_PROFILE = "/advisor/profile/information";
const URL_LOGIN = "/";
const URL_PLAN_SETTINGS = "/admin/settings/plan-settings";
const URL_CUSTOMIZATION = "/admin/customization";
const URL_USERS = "/admin/users";
const URL_TEAMS = "/admin/teams";
const URL_ADMIN_SUBSCRIPTION = "/admin/billing/subscription";

class ConnectedUserMenu extends Component {
  state = {
    anchorMenu: null,
    doRedirect: false,
    redirectTarget: null,
  };

  toggleMenu = (event) => {
    this.setState({
      ...this.state,
      anchorMenu: event.currentTarget,
    });
  };

  closeMenu = () => {
    this.setState({
      ...this.state,
      anchorMenu: null,
    });
  };

  redirectToUrl = (url) => {
    this.setState({
      ...this.state,
      doRedirect: true,
      redirectTarget: url,
      anchorMenu: null,
    });
  };

  logout = () => {
    spring_security_logout().then(() => {
      this.props.clearUser();

      setTimeout(() => {
        this.redirectToUrl(URL_LOGIN);
      }, 10);
    });
  };

  render() {
    const { anchorMenu } = this.state;
    const open = Boolean(anchorMenu);

    if (this.state.doRedirect) {
      this.setState({
        ...this.state,
        doRedirect: false,
      });
      return <Redirect to={this.state.redirectTarget} />;
    }

    let currentUser = this.props.currentUser.toJS();

    const currentUserName = `${currentUser.firstName} ${currentUser.lastName}`;

    return (
      <React.Fragment>
        <div className={"top-menu-account"}>
          <label className={"top-menu-account-label"}>Account:</label>
          <span className={"top-menu-user-name"}>
            {truncateContent(currentUserName, 14)}
          </span>
        </div>

        <IconButton
          aria-owns={open ? "menu-appbar" : undefined}
          aria-haspopup="true"
          onClick={this.toggleMenu}
          color="inherit"
          size="large"
        >
          <UserAvatar
            name={currentUser.firstName}
            imageUrl={currentUser.imageUrl}
            className={"avatar-button"}
          />
          <MoreVertIcon className={"vert-icon"} />
        </IconButton>

        <Menu
          id="menu-appbar"
          className={"user-menu"}
          anchorEl={anchorMenu}
          open={open}
          onClose={this.closeMenu}
        >
          {this.props.currentUser.get("hasAdminAccess") && (
            <React.Fragment>
              <h4 className={"user-menu-title"}>Admin Settings</h4>
              <MenuItem
                onClick={() => {
                  this.redirectToUrl(URL_PLAN_SETTINGS);
                }}
              >
                Plan Settings
              </MenuItem>
              <MenuItem
                onClick={() => {
                  this.redirectToUrl(URL_CUSTOMIZATION);
                }}
              >
                Customization
              </MenuItem>
              <MenuItem
                onClick={() => {
                  this.redirectToUrl(URL_USERS);
                }}
              >
                Users
              </MenuItem>
              <MenuItem
                onClick={() => {
                  this.redirectToUrl(URL_TEAMS);
                }}
              >
                Teams
              </MenuItem>
              <MenuItem
                onClick={() => {
                  this.redirectToUrl(URL_ADMIN_SUBSCRIPTION);
                }}
              >
                Admin Subscription
              </MenuItem>
              <hr />
            </React.Fragment>
          )}
          <h4 className={"user-menu-title"}>Advisor</h4>
          <MenuItem
            onClick={() => {
              this.redirectToUrl(URL_PROFILE);
            }}
          >
            Profile
          </MenuItem>
          <MenuItem
            onClick={() => {
              this.redirectToUrl(URL_SUBSCRIPTION);
            }}
          >
            Advisor Subscription
          </MenuItem>
          <hr />
          <MenuItem
            onClick={() => {
              this.logout();
            }}
          >
            Sign out
          </MenuItem>
        </Menu>
      </React.Fragment>
    );
  }
}

const mapStateToUserProps = (state) => {
  return {
    currentUser: state.currentUserReducer,
  };
};

const mapDispatchToUserMenuProps = (dispatch) => {
  return {
    clearUser: () =>
      dispatch({
        type: actionTypes.CLEAR_CURRENT_USER_DATA,
      }),
    openProfile: () =>
      dispatch({
        type: actionTypes.SHOW_USER_PROFILE_MODAL,
      }),
  };
};

const UserMenu = connect(
  mapStateToUserProps,
  mapDispatchToUserMenuProps
)(ConnectedUserMenu);

const Header = (props) => {
  const [state, setState] = useState({
    searchText: "",
  });

  const onDrawerToggle = props.onDrawerToggle;

  let trialCounterComponent;
  if (props.showTrialCounter) {
    trialCounterComponent = (
      <React.Fragment>
        <Grid item xs />
        <Grid item xs={2}>
          <span className={"trial-label"}>Trial ends in </span>
          <TrialCounter
            creationDate={new Date(props.trialCounterCreationDate)}
          />
        </Grid>
      </React.Fragment>
    );
  } else {
    trialCounterComponent = <Grid item xs />;
  }

  return (
    <React.Fragment>
      <AppBar position="sticky" elevation={0}>
        <Notifications />
        <Toolbar>
          <Grid container alignItems="center">
            <Hidden mdUp>
              <Grid item>
                <IconButton
                  color="inherit"
                  aria-label="Open drawer"
                  onClick={onDrawerToggle}
                  size="large"
                >
                  <MenuIcon />
                </IconButton>
              </Grid>
            </Hidden>
            <Grid
              className={"top-search-bar"}
              item
              xs={props.showTrialCounter ? 7 : 8}
            >
              <Search>
                <Input
                  value={state.searchText}
                  onChange={(event) => {
                    setState({
                      ...state,
                      searchText: event.target.value,
                    });
                  }}
                  onKeyDown={(event) => {
                    if (event.keyCode === 13) {
                      props.history.push(
                        `/advisor/clients?search=${state.searchText}`
                      );
                    }
                  }}
                  placeholder="Search Clients"
                />
                <div className={"search-icon"}>
                  <SearchIcon
                    onClick={() => {
                      props.history.push(
                        `/advisor/clients?search=${state.searchText}`
                      );
                    }}
                  />
                </div>
              </Search>
            </Grid>
            {trialCounterComponent}
            <Grid item className={"user-menu-container"}>
              <UserMenu />
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    </React.Fragment>
  );
};

const mapStateToHeaderProps = (state) => {
  return {
    currentUser: state.currentUserReducer,
    showTrialCounter: state.uxStateReducer.getIn(["showTrialCounter"]),
    trialCounterCreationDate: state.uxStateReducer.getIn([
      "trialCounterCreationDate",
    ]),
  };
};

export default connect(mapStateToHeaderProps)(withRouter(withTheme(Header)));
